// DashBoard.js
import React, { useState } from 'react';
import { FaUserPlus, FaTruck, FaMoneyBillWave, FaFileInvoice, FaTag, FaListAlt, FaDatabase, FaShoppingBag, FaReceipt, FaBalanceScale, FaBoxOpen, FaClipboardCheck, FaTruckMoving, FaBook, FaChartBar, FaFileAlt, FaCalendarAlt, FaUsers, FaHandshake, FaFileExcel, FaChartLine, FaBookReader, FaFacebookMessenger, FaBroadcastTower, FaFileInvoiceDollar } from 'react-icons/fa';
import DashboardButton from '../../Common/Buttons/DashboardButton';
import "./DashBoard.css";
import axios from 'axios';
import Swal from 'sweetalert2';
import SaveUpdateSpinner from "../../Common/Spinners/SaveUpdateSpinner"

const API_URL = process.env.REACT_APP_API;

const DashBoard = () => {

  const [isLoading, setIsLoading] = useState(false);
  const Year_Code = sessionStorage.getItem("Year_Code");
  const companyCode = sessionStorage.getItem("Company_Code");
  const uid = sessionStorage.getItem("uid");

  //Genrate the Backup
  const handleBackupClick = async () => {
    setIsLoading(true);
    try {
      const response = await axios.post(`${API_URL}/backup`);
      const data = response.data;

      if (data.success) {
        Swal.fire({
          title: 'DataBase Backup Successfully!',
          icon: 'success',
          confirmButtonText: 'OK'
        });
      } else {
        Swal.fire({
          title: 'DataBase Backup Failed!',
          text: data.error || 'No additional details available',
          icon: 'error',
          confirmButtonText: 'OK'
        });
      }
    } catch (error) {
      Swal.fire({
        title: 'Backup Error!',
        text: error.response ? error.response.data.message : error.message,
        icon: 'error',
        confirmButtonText: 'OK'
      });
    } finally {
      setIsLoading(false);
    }
  };

  const handleCompanyLogsClick = async () => {
    setIsLoading(true);
    try {
      const userCheckUrl = `${API_URL}/get_user_permissions?Company_Code=${companyCode}&Program_Name=/companylogs&uid=${uid}`;
      const response = await axios.get(userCheckUrl);
      const userDetails = response.data?.UserDetails;

      if (userDetails?.canView === "Y") {
        window.open("/companylogs", "_blank");
      } else {
        Swal.fire({
          title: 'Access Denied!',
          text: 'You do not have Permission to view Company Logs.',
          icon: 'error',
          confirmButtonText: 'OK'
        });
      }
    } catch (error) {
      console.error("Error fetching user permissions:", error);
      Swal.fire({
        title: 'Access Denied!',
        text: 'You do not have Permission to view Company Logs.',
        icon: 'error',
        confirmButtonText: 'OK'
      });
    } finally {
      setIsLoading(false);
    }
  };


  const handleDailySale = () => {
    const url = '/periodic-sale-report';
    window.open(url, '_blank');
  }


  const handleMonthlySale = () => {
    const url = '/periodic-sale-report-bar-chart';
    window.open(url, '_blank');
  }

  const handleLiveETenders = () => {
    const url = '/live-tenders';
    window.open(url, '_blank');
  }

  const handleallLiveTenders = () => {
    const url = '/live-alltenders';
    window.open(url, '_blank');
  }

  
  const handlegst3bitcreport = () => {
    const url = '/gst3b-report';
    window.open(url, '_blank');
  }



  return (
    <>
      <div className="CommonbuttonContainer" style={{ marginTop: "100px" }}>
        <DashboardButton label="Ledger" icon={FaFileAlt} path="/ledger" />
        <DashboardButton label="Receipt Payment" icon={FaReceipt} path="/RecieptPaymentUtility" />
        <DashboardButton label="UTR Entry" icon={FaMoneyBillWave} path="/utrentry-Utility" />
        <DashboardButton label="Tender Purchase" icon={FaFileInvoice} path="/tender-purchaseutility" />
        <DashboardButton label="Delivery Order" icon={FaTruck} path="/delivery-order-utility" />
      </div>

      <div className="CommonbuttonContainer">
        <DashboardButton label="Day Book" icon={FaCalendarAlt} path="/daybook" />
        <DashboardButton label="Trial Balance" icon={FaBalanceScale} path="/trial-balance" />
        <DashboardButton label="Register" icon={FaListAlt} path="/register" />
        <DashboardButton label="Sugar Balance Stock" icon={FaBoxOpen} path="/sugar-balance-stock" />
        <DashboardButton label="Corporate Sale" icon={FaShoppingBag} path="/corporate-sale" />
      </div>

      <div className="CommonbuttonContainer">
        <DashboardButton label="Dispatch Summary" icon={FaClipboardCheck} path="/register" />
        <DashboardButton label="Transport SMS" icon={FaFacebookMessenger} path="/transport-sms" />
        <DashboardButton label="Stock Book" icon={FaBook} path="/balance-stock" />
        <DashboardButton label="Stock Summary" icon={FaBookReader} path="/stock-book" />
        <DashboardButton label="Company Logs" icon={FaFileInvoice} path="/companylogs" onClick={handleCompanyLogsClick} />
      </div>

      <div className="CommonbuttonContainer">
        <DashboardButton label="Multiple Receipt" icon={FaReceipt} path="/multiple-receipt" />
        {/* <DashboardButton label="Database Backup" icon={FaDatabase} path="/database-backup" onClick={handleBackupClick} /> */}
        <DashboardButton label="Daily Sale" icon={FaChartLine} path="/periodic-sale-report" onClick={handleDailySale} />
        <DashboardButton label="Monthly Sale" icon={FaChartBar} path="/periodic-sale-report-bar-chart" onClick={handleMonthlySale} />
        <DashboardButton label="Daily Purchase" icon={FaTag} path="/live-alltenders" onClick={handleallLiveTenders} />
        <DashboardButton label="Daily Sauda" icon={FaBroadcastTower} path="/live-tenders" onClick={handleLiveETenders} />
        <DashboardButton label="GST 3B ITC Report" icon={FaFileInvoiceDollar} path="/gst3b-report" onClick={handlegst3bitcreport} />
      </div>
      {isLoading && (
        <div className="loading">
          <SaveUpdateSpinner />
        </div>
      )}
    </>
  );
}

export default DashBoard;
